
import { Component, Input } from '@angular/core';
import { IonicModule, PopoverController } from '@ionic/angular';
import { safeDismiss } from 'src/app/services/session-service/safe-dismiss';

@Component({
  selector: 'app-protocol-popover',
  standalone: true,
  template: `
    <ion-list>
  <ion-item button (click)="edit()">
    <ion-icon name="create" slot="start"></ion-icon>
    <ion-label>Edit</ion-label>
  </ion-item>
  <ion-item button (click)="remove()">
    <ion-icon name="trash" slot="start"></ion-icon>
    <ion-label>Remove</ion-label>
  </ion-item>
  <ion-item button (click)="load()">
    <ion-icon name="cloud-download" slot="start"></ion-icon>
    <ion-label>Load</ion-label>
  </ion-item>
</ion-list>
  `,
  imports: [IonicModule],
})
export class ProtocolPopoverComponent {
  @Input() protocol: any;
  @Input() editProtocol!: (protocolId: string) => void;
  @Input() removeProtocol!: (protocolId: string) => void;
  @Input() loadProtocol!: (protocolRoot: string) => void;

  constructor(private popoverCtrl: PopoverController) {}

  async edit() {
    if (this.editProtocol) {
      this.editProtocol(this.protocol.id);
    }
    await safeDismiss(this.popoverCtrl);
  }

  async remove() {
    if (this.removeProtocol) {
      this.removeProtocol(this.protocol.id);
    }
    await safeDismiss(this.popoverCtrl);
  }

  async load() {
    if (this.loadProtocol) {
      this.loadProtocol(this.protocol.url);
    }
    await safeDismiss(this.popoverCtrl);
  }
}